/** @format */

import {makeStyles} from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
  successMessage: {
    color: theme.palette.success.main,
    fontSize: 14,
    marginTop: theme.spacing(1),
  },

  headerTitle: {
    fontSize: '28px',
    fontWeight: 700,
  },
  rowNew: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: theme.spacing(4),
    borderRadius: '8px',
    background: '#202020',
    '& .MuiTextField-root': {
      marginTop: 0,
    },
  },
  label: {
    marginBottom: theme.spacing(4),
    color: '#8B8B8B',
    fontSize: '14px',
    fontWeight: 400,
    letterSpacing: '0.131px',
  },
  textField: {
    width: '100%',
    marginTop: theme.spacing(4),
    borderRadius: '8px',
    background: 'transparent',
  },
  passwordButtonNew: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: theme.spacing(4),
    borderRadius: '8px',
    background: 'transparent',
    borderColor: '#4D4E4E',
    '& .MuiButton-label div': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  },
  hiddenPasswordField: {
    marginLeft: theme.spacing(4),
    color: '#8B8B8B',
    fontSize: '14px',
    letterSpacing: '0.131px',
  },
  securityTitle: {
    fontSize: '16px',
    margin: 0,
    fontWeight: 700,
    letterSpacing: '0.131px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
    },
  },
  securityDescription: {
    margin: 0,
    marginTop: theme.spacing(4),
    color: '#8B8B8B',
    fontSize: '14px',
    fontWeight: 400,
    letterSpacing: '0.131px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
    },
  },
  twoFATextField: {
    flexGrow: '1',
    '&:placeholder': {
      color: '#8B8B8B',
      fontSize: '14px',
      fontWeight: 400,
      letterSpacing: '0.131px',
    },
  },
  twoFAIcon: {
    top: '28px',
  },
  twoFAButton: {
    marginTop: theme.spacing(8),
    fontSize: '14px',
    fontWeight: 400,
    letterSpacing: '0.131px',
    '&:disabled': {
      background: '#2B2B2B',
      color: '#8B8B8B',
    },
    '&:enabled': {
      background: '#8B8B8B',
    },
  },
  twoFAButtonWithError: {
    marginTop: theme.spacing(2),
  },
  twoFAContainer: {
    width: '100%',
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  inputIcon: {
    marginRight: theme.spacing(2),
  },
  twoFAInnerContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
}));
